var render = function render(){var _vm=this,_c=_vm._self._c;return _c('input',{attrs:{"type":"radio","name":_vm.name},domProps:{"value":_vm.move},on:{"click":function($event){return _vm.$emit('update',_vm.name,_vm.move)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }